export function parseItemDetails(value) {
  if (value == null || value === '') return [];

  const flattenEntry = (item) => {
    if (typeof item !== 'string') return [];
    const trimmed = item.trim();
    if (!trimmed || trimmed === '[]') return [];

    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parseItemDetails(parsed);
        }
      } catch {
        // fall through
      }
    }

    return [trimmed];
  };

  if (Array.isArray(value)) {
    return value.flatMap(flattenEntry).filter(Boolean);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return [];

    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parseItemDetails(parsed);
        }
      } catch {
        return [trimmed];
      }
    }

    return [trimmed];
  }

  return [];
}
